var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import BaseSvgIcon from "./Base";
var DownloadFile = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 64 64" }),
        React.createElement("g", null,
            React.createElement("polygon", { fill: "none", stroke: "#000000", strokeWidth: "2", strokeMiterlimit: "10", points: "23,1 55,1 55,63 9,63 9,15 \t" }),
            React.createElement("polyline", { fill: "none", stroke: "#000000", strokeWidth: "2", strokeMiterlimit: "10", points: "9,15 23,15 23,1 \t" })),
        React.createElement("polyline", { fill: "none", stroke: "#000000", strokeWidth: "2", strokeLinejoin: "bevel", strokeMiterlimit: "10", points: "40,37 32,45 \n        24,37 " }),
        React.createElement("g", null,
            React.createElement("line", { fill: "none", stroke: "#000000", strokeWidth: "2", strokeMiterlimit: "10", x1: "32", y1: "45", x2: "32", y2: "25" }))));
};
export default DownloadFile;
